import {
  Inject,
  Injectable,
  Optional,
  SkipSelf,
  InjectionToken,
  ElementRef,
  OnDestroy,
  SecurityContext,
  Renderer2,
  RendererFactory2,
  RendererType2,
  DOCUMENT,
} from "@angular/core";

import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxPanelHelperService implements OnDestroy {
  private panels = new Set();
  private rendererWeakMap = new WeakMap();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _sanitizer: DomSanitizer,
  ) {}

  getPanel(panelStyleClass: string, renderer: Renderer2, document: any = null): Element {
    let panel = renderer.createElement("div");

    panel.setAttribute("class", this._sanitizer.sanitize(SecurityContext.HTML, panelStyleClass));

    if (document != null) {
      document.body.appendChild(panel);
    } else {
      this.document.body.appendChild(panel);
    }

    this.panels.add(panel);
    this.rendererWeakMap.set(panel, renderer);

    return panel;
  }

  destroy(panel: Element): void {
    if (this.panels.has(panel)) {
      let renderer = this.rendererWeakMap.get(panel);
      if (renderer) renderer.removeChild(this.document.body, panel);
    }
  }

  ngOnDestroy(): void {
    this.panels.forEach((panel: any) => {
      if (panel && panel.nativeElement) {
        let renderer = this.rendererWeakMap.get(panel);
        if (renderer) renderer.removeChild(this.document.body, panel);
      }
    });
  }
}
